import * as fromSchoolSearchResults from '../actions/reports-school-searchresults.action';
import * as fromModels from '../../../scp/schools/models';
import { HttpHeaders } from '@angular/common/http';

export interface ReportsSearchResultsState {
  searchResults: fromModels.SchoolSearchResultsItem[];
  searchCriteria: fromModels.SchoolSearchCriteria;
  pagingSorting: fromModels.SchoolPagingSorting;
  errors: any;	//	TODO: formalize error handling
  loading: boolean;
  loaded: boolean;
  length: number;
}

export const initialState: ReportsSearchResultsState = {
  loading: false,
  loaded: false,
  searchResults: null,
  errors: null,
  length: null,
  searchCriteria: {
    callDay: null,
    code: null,
    county: null,
    districtId: null,
    districtName: null,
    gradeLevel: null,
    id: null,
    isActive: null,
    longName: null,
    offersBandshare: null,
    PageNumber: null,
    PageSize: null,
    phone: null,
    primaryFulfillmentSite: null,
    radius: null,
    schoolType: null,
    SortBy: null,
    SortDir: null,
    state: null,
    teacherId: null,
    zip: null,
  },
  pagingSorting: {
    totalCount: null,
    pageSize: null,
    currentPage: null,
    totalPages: null,
    sortBy: null,
    sortDir: null
  }
};

export function reducer(state = initialState, action: fromSchoolSearchResults.ReportsSchoolSearchResultsActions): ReportsSearchResultsState {
  switch (action.type) {
    case fromSchoolSearchResults.ReportsSchoolSearchResultsActionTypes.ProcessReportQueryString: {
      console.log('ProcessReportQueryString');
      console.log(action.payload);

      return {
        ...state,
        loaded: false,
        loading: false,
        errors: null
      };
    }

    case fromSchoolSearchResults.ReportsSchoolSearchResultsActionTypes.LoadReportSchoolSearchResults: {
      console.log('LoadSchoolSearchResults');
      console.log(action.payload);
      return {
        ...state,
        loaded: false,
        loading: true,
        errors: null,
        // Anytime we request search results, let's update the state to include that
        // most recent criteria that was just passed.
        searchCriteria: action.payload
      };
    }

    case fromSchoolSearchResults.ReportsSchoolSearchResultsActionTypes.LoadReportSchoolSearchResultsSuccess: {
      const searchResults = action.payload;
      const headers = action.httpHeaders;
      const length = action.payload.length;

      return {
        ...updateSchoolSearchResultsState(state, searchResults, headers),
        loaded: true,
        loading: false
      };
    }

    case fromSchoolSearchResults.ReportsSchoolSearchResultsActionTypes.LoadReportSchoolSearchResultsFailure: {
      console.log('reducer:', action);

      return {
        ...state,
        loaded: false,
        loading: false,
        errors: action.payload
      };
    }
  }

  return state;
}

function updateSchoolSearchResultsState(state: ReportsSearchResultsState, searchResults: fromModels.SchoolSearchResultsItem[], headers: HttpHeaders) {
  let pagingSorting: fromModels.SchoolPagingSorting;

  // Grab special header we use for paging
  const pagingHeader: string = headers.get('X-Pagination');
  const pagingObject: object = JSON.parse(pagingHeader);

  // Populate paging information from http headers
  pagingSorting = {
    totalCount: pagingObject['totalCount'],
    pageSize: pagingObject['pageSize'],
    currentPage: pagingObject['currentPage'],
    totalPages: pagingObject['totalPages'],
    sortBy: pagingObject['sortBy'],
    sortDir: pagingObject['sortDir']
  };

  return {
    ...state,
    searchResults,
    pagingSorting
  };
}

export const getReportsSchoolSearchResults = (state: ReportsSearchResultsState) => state.searchResults;
export const getReportsSchoolSearchLoading = (state: ReportsSearchResultsState) => state.loading;
export const getReportsSchoolSearchLoaded = (state: ReportsSearchResultsState) => state.loaded;
export const getReportsSchoolSearchErrors = (state: ReportsSearchResultsState) => state.errors;
